import { render, staticRenderFns } from "./WalletError.vue?vue&type=template&id=2582c00b&"
import script from "./WalletError.vue?vue&type=script&lang=js&"
export * from "./WalletError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports